import * as React from 'react';
import { Or } from '../../../domain/Or';
import { TRenderable } from '../SharedTypes';
import { Style } from '../Styles/CSS';

export function ImageWithOverlay({
	id,
	options,
	children
}: {
	id?: string;
	options: IImageWithOverlayOptions;
	children?: TRenderable | TRenderable[];
}) {
	const imageCSS = Or(options.imageCSS, {});

	const imageCSSExtended = {
		backgroundImage: `url("${options.imageUrl}")`,
		backgroundRepeat: `no-repeat`,
		width: options.imageWidth,
		height: options.imageHeight,
		backgroundSize: `cover`,
		display: `flex`,
		alignItems: `center`,
		justifyContent: `center`,
		position: `relative`,
		...imageCSS
	} as React.CSSProperties;

	const imageClass = Style(`imageWithOverlay_${options.imageLabel}`, imageCSSExtended);

	return <span id={id} {...imageClass}>{children}</span>;
}

export interface IImageWithOverlayOptions {
	imageLabel: string;
	imageUrl: string;
	imageWidth: number;
	imageHeight: number;
	imageCSS?: React.CSSProperties;
}
